import { Input } from 'antd';
import type { ComponentProps } from 'react';

const { TextArea: TextAreaA } = Input;

export type TextAreaProperties = ComponentProps<typeof TextAreaA>;

const TextArea = (props: TextAreaProperties) => <TextAreaA rows={4} size="large" {...props} />;

export default TextArea;
